/**
 * Created by why on 2019/10/21.
 */
/**
 * Created by why on 2019/10/21.
 */
import axios from '@/libs/api.request'
export const dictList = () => {
  return axios.request({
    url: '/dict/selectAll',
    method: 'get'
  })
}

export const getByDictType = (data) => {
  return axios.request({
    url: '/dictDetail/getByDictType',
    params: data,
    method: 'get'
  })
}

export const dictDataList = (data) => {
  return axios.request({
    url: '/dictDetail/getByCondition',
    params: data,
    method: 'get'
  })
}

export const dictDataInsert = (basDict) => {
  return axios.request({
    url: '/dictDetail/save',
    data: basDict,
    method: 'post'
  })
}

export const dictInsert = (data) => {
  return axios.request({
    url: '/dict/save',
    data: data,
    method: 'post'
  })
}

export const dictUpdate = (data) => {
  return axios.request({
    url: '/dict/edit',
    data: data,
    method: 'post'
  })
}

export const dictDataUpdate = (data) => {
  return axios.request({
    url: '/dictDetail/edit',
    data: data,
    method: 'post'
  })
}

export const dictDelete = (id) => {
  return axios.request({
    url: `/dict/delByIds/${id}`,
    method: 'delete'
  })
}

export const dictDataDelete = (ids) => {
  return axios.request({
    url: `/dictDetail/delByIds/${ids}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/dict-manage.js